<template>
  <div class="keywords-examples">
    <span class="close" @click="close">×</span>
    <div class="examples-grid">
      <div v-for="(item, key) in examples" :key="key"
        class="examples-grid-item">
        <div class="example-logo">
          <img :src="`img/${item.logo}`" alt="logo"></div>
        <div class="keywords-list">
          <span v-for="(keyword, i) in item.keywords" :key="i">
            {{keyword}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeywordsExamples',
  data() {
    return {
      examples: [{
        logo: 'bitcoin.svg',
        keywords: [
          'Bitcoin',
          'abstract',
        ]
      }, {
        logo: 'yum.svg',
        keywords: [
          'snack',
          'cookie',
        ]
      }, {
        logo: 'seattle.svg',
        keywords: [
          'Seattle',
          'trendy',
        ]
      }, {
        logo: 'daisy.svg',
        keywords: [
          'flower',
          'organic',
        ]
      }],
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.keywords-examples {
  position: relative;

  .close {
    position: absolute;
    top: -1em;
    right: 0;
    font-size: 3em;
    padding: .25em;
    cursor: pointer;
  }

  .examples-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .examples-grid-item {
      padding: 1em 0;

      &:nth-child(n+3) {
        display: none;
      }

      .example-logo {
        background-color: $pale-teal-dark;
        width: 7.5em;
        height: 7.5em;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .keywords-list {
        margin-top: .625em;
        opacity: .75;

        span {
          margin-right: 1em;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .keywords-examples {

    .examples-grid {

      .examples-grid-item {

        &:nth-child(n+3) {
          display: block;
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .keywords-examples {

    .examples-grid {

      .examples-grid-item {
        padding: 1em 1em;
      }
    }
  }
}
</style>
